export default {"src":"/_next/static/media/badge-3-yellow.56eade50.svg","height":144,"width":144};